import { lazy } from 'react';

export const UpdateAnnouncementPageLazy = lazy(() => import('./UpdateAnnouncementPage'));
